import { VimeoFrame } from "src/utils/fw"
import { isMember } from "../utils"


export default {
	background: "https://assets.swoogo.com/uploads/full/1447633-617a72c870c43.jpg",
	extras: (
		<>
			<iframe allowfullscreen frameborder="0" id="sponsor-theatre-screen"
				style={{
					width: "calc(67.4% * 1.33333)",
					height: "calc(76.6% * 1.33333)",
					left: "16.2%",
					top: ".9%",
					position: "absolute",
					cursor: "pointer",
					display: "block",
					zIndex: "5",
					overflow: "hidden",
					transformOrigin: "top left",
					transform: "scale(0.75)",
				}}
				src=""
			/>
		</>
	),
	links: [
		{
			gameRule: "sponsor-theatre-beyondtrust",
			height: "6%",
			label: "BeyondTrust",
			left: ".8%",
			top: "14%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639882194?h=0253230a97&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-bitsight",
			height: "6%",
			label: "BitSight",
			left: ".8%",
			top: "21.8%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639884898?h=1577f64f62&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-crossword",
			height: "6%",
			label: "Crossword Cybersecurity",
			left: ".8%",
			top: "29.6%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639885150?h=9f4f40eb8c&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-crowdstrike",
			height: "6%",
			label: "CrowdStrike",
			left: ".8%",
			top: "37.6%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639885407?h=4d988e7d2a&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-cybel",
			height: "6%",
			label: "CybelAngel",
			left: ".8%",
			top: "45.4%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639885617?h=83e1091fa3&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-huawei",
			height: "6%",
			label: "Huawei Technologies",
			left: ".8%",
			top: "53%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639881174?h=d802c93fbf&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-ibm",
			height: "6%",
			label: "IBM Security",
			left: ".8%",
			top: "60.5%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639881387?h=a885f18db3&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-immuniweb",
			height: "6%",
			label: "Immuniweb",
			left: ".8%",
			top: "68.5%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639881548?h=dad08b3368&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-keysight",
			height: "5.7%",
			label: "Keysight Technologies",
			left: "84.5%",
			top: "2.1%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639879283?h=0bbfb51932&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-kpmg",
			height: "6%",
			label: "KPMG",
			left: "84.5%",
			top: "10%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639883623?h=bfe0dc93d5&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-onetrust",
			height: "6%",
			label: "OneTrust",
			left: "84.5%",
			top: "17.9%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639879394?h=c1201d8fe9&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-scorecard",
			height: "6%",
			label: "SecurityScorecard",
			left: "84.5%",
			top: "25.8%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639879550?h=c9d75382b9&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-sentinel",
			height: "6%",
			label: "SentinelOne",
			left: "84.5%",
			top: "33.5%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639883872?h=3386feee5d&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-surecloud",
			height: "6%",
			label: "Surecloud",
			left: "84.5%",
			top: "41.3%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639881786?h=dafdd74645&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-synopsys",
			height: "6%",
			label: "Synopsis",
			left: "84.5%",
			top: "49%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639884425?h=07520ec4b6&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-tessian",
			height: "6%",
			label: "Tessian",
			left: "84.5%",
			top: "56.7%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639879694?h=2eb88e79af&autoplay=1" />,
		},
		{
			gameRule: "sponsor-theatre-veracode",
			height: "6%",
			label: "Veracode",
			left: "84.5%",
			top: "64.5%",
			width: "14.4%",
			modal: <VimeoFrame vidId="639881979?h=6ba8321251&autoplay=1" />,
		},
	],
	name: "sponsor-theatre",
}
